import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import { reducer as formReducer } from 'redux-form';
import funnelCancelModal from 'Redesign_Funnel/containers/pages/FunnelLayout/store/duck';
import pusher from 'Contexts/PusherDuck';
import application from './application';
import fieldAsync from './async';
import loans from './loans';
import { onBoardingReducer } from './onBoarding';

export default history => combineReducers({
  application,
  fieldAsync,
  form: formReducer,
  funnelCancelModal,
  loans,
  onBoarding: onBoardingReducer,
  pusher,
  router: connectRouter(history),
});
